import { observer } from 'mobx-react';
import React, { useEffect, useRef } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { NavLink, useHistory } from 'react-router-dom';
import logo from '../../assets/Images/logo.jpg';
import { ModuleType } from '../../constants/enums/module-type-enum';
import userTypeEnum from '../../constants/enums/user-type-enum';
import { useStore } from '../../contexts/store-provider';
import {
  getIsTenantAccessFromLocalStorage,
  getTenantIdFromLocalStorage,
  getTenantIdFromToken,
  getUserTypeFromLocalStorage,
} from '../../helpers/localstorage-helper';
import { findRouteAccess } from '../../helpers/route-helper';
import LogoutPopup from '../../modules/auth/components/logout-popup';
import LogoutPopupHOC from '../../modules/auth/hoc/logout-popup-hoc';
import ProjectInfoHOC from '../../modules/auth/hoc/project-info-popup-hoc';
import ProjectInfo from '../../modules/auth/components/project-info';
import UserProfilePopupHOC from '../../modules/auth/hoc/user-profile-popup-hoc';
import UserProfilePopup from '../../modules/auth/user-profile-popup';
import { formatMessage } from '../../translations/format-message';
import FormLoader from '../FormLoader/FormLoader';
import RoutesConstants from '../routes/routes-constants';
import { ExclamationCircleFill } from 'react-bootstrap-icons';
import './left-navbar.css';
import {
  ActiveTrayManagementIcon,
  AIMSPortalIcon,
  ExitTenantIcon,
  FactoryAccessIcon,
  GroupManagementIcon,
  HKRScheduleDataIcon,
  HolidayCalendarIcon,
  KishuManagementIcon,
  LogoutIcon,
  OperatorMenuIcon,
  OrderTableViewIcon,
  ProcessManagementIcon,
  ProcessTemplateManagementIcon,
  ProductManagementIcon,
  ProfileIcon,
  TenantManagementIcon,
  TeplarPrintTemplateManagementIcon,
  TrayManagementIcon,
  UserLogsIcon,
  UserManagementIcon,
  DimensionIcon,
  CheckItemTemplateIcon,
  TrayTagReassignmentIcon,
  BomSearchIcon,
  ToolManagementIcon,
  ToolCheckItemTemplateIcon,
  DefectiveItemsIcon,
  NonConfirmatoryIcon,
  NonconformityReportIcon,
} from '../svgs/module-svgs';

interface IProps {
  changeLanguage: (lang: string) => void;
}

const LeftNavBar = (props: any) => {
  const history = useHistory();
  const { preferencesStore, authStore, correctionControlStore, productStore } =
    useStore();
  const myRef = useRef<any>();
  const { getUserType, userType, getEmail } = authStore;
  const {
    GetPendingCountService,
    resetGetPendingCountState,
    pendingCount,
    addCorrectionRequestState,
  } = correctionControlStore;

  const { updateCorrectionControlState } = productStore;
  const {
    getTenantAccess,
    setTenantAccess,
    resetMediaAccess,
    resetPriceSchedulerAccess,
    resetUnwantedModules,
    GetAPIVersionService,
    getAPIVersionServiceState,
    version,
  } = preferencesStore;
  const isOmsUser =
    (getUserType === userTypeEnum[0] ||
      getUserType === userTypeEnum[1] ||
      getUserType === userTypeEnum[4]) &&
    getIsTenantAccessFromLocalStorage() == false;
  const isCompany =
    (getUserType === userTypeEnum[2] || getUserType === userTypeEnum[3]) &&
    getIsTenantAccessFromLocalStorage() == false;

  const handleChange = () => {
    const div = document.getElementById('left-sidebarNav');
    const move = document.getElementById('moveContent');
    if (div) {
      if (!div.className.includes('closeNav')) {
        div.classList.add('closeNav');
        if (move) move.classList.remove('ShiftLeftSide');
      } else {
        div.classList.remove('closeNav');
        if (move) move.classList.add('ShiftLeftSide');
      }
    }
  };
  const userType1 = getUserTypeFromLocalStorage();
  const isOperator =
    getUserType === userTypeEnum[userTypeEnum.Operator] ||
    getUserType === userTypeEnum[6];

  const handleChange2 = () => {
    const div = document.getElementById('left-sidebarNav');
    const move = document.getElementById('moveContent');
    if (div !== null) {
      div.classList.add('closeNav');
      if (move) move.classList.remove('ShiftLeftSide');
    }
  };

  // const closeOnOutsideClick = () => {
  //   var div = document.getElementById("left-sidebarNav");
  //   const move = document.getElementById("moveContent");
  //   if (div) {
  //     if (!div.className.includes("closeNav")) {
  //       div.classList.add("closeNav");
  //       if (move) move.classList.remove("ShiftLeftSide");
  //     }
  //   }
  // };

  const handleClickOutside = (e: any) => {
    if (!myRef.current.contains(e.target)) {
      // closeOnOutsideClick();
    }
  };

  const resetExtraModules = () => {
    resetUnwantedModules();
  };

  const fetchPendingCount = () => {
    const tenantId = getTenantIdFromLocalStorage();
    if (tenantId && Number(tenantId) > 0) {
      GetPendingCountService(Number(tenantId));
    }
  };

  useEffect(() => {
    GetAPIVersionService();
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (!isOperator) {
      fetchPendingCount();
      const intervalId = setInterval(fetchPendingCount, 30 * 60 * 1000);
      const unlisten = history.listen(() => {
        fetchPendingCount();
      });

      return () => {
        clearInterval(intervalId);
        unlisten();
      };
    }
  }, [isOperator, getTenantAccess?.tenantId, history]);

  useEffect(() => {
    if (!isOperator && updateCorrectionControlState.success) {
      fetchPendingCount();
    }
  }, [isOperator, updateCorrectionControlState.success]);

  useEffect(() => {
    if (!isOperator && addCorrectionRequestState.success) {
      fetchPendingCount();
    }
  }, [isOperator, addCorrectionRequestState.success]);

  const exitTenant = () => {
    setTenantAccess({
      isAccessTenantActive: false,
      tenantId: 0,
      tenantName: '',
      orgId: '',
    });
    resetMediaAccess();
    resetPriceSchedulerAccess();
    resetGetPendingCountState();
    // closeOnOutsideClick();
    const div = document.getElementById('exit');
    const move = document.getElementById('moveContent');
    if (div) {
      if (!div.className.includes('closeNav')) {
        div.classList.add('closeNav');
        if (move) move.classList.remove('ShiftLeftSide');
      } else {
        div.classList.remove('closeNav');
        if (move) move.classList.add('ShiftLeftSide');
      }
    }
    history.push(RoutesConstants.TenantManagement);
  };

  const exitTenantHandler = () => {
    resetMediaAccess();
    resetPriceSchedulerAccess();
    resetGetPendingCountState();
    // closeOnOutsideClick();
    history.push(RoutesConstants.TenantManagement);
  };
  return (
    <React.Fragment>
      {getAPIVersionServiceState.inProgress && (
        <FormLoader loading={getAPIVersionServiceState.inProgress} />
      )}

      {props.showUserProfilePopup && (
        <UserProfilePopup
          userName={props.email}
          userType={props.userType}
          modalClosed={props.UserProfileToggleHandler}
        />
      )}
      {props.showLogoutPopup && (
        <LogoutPopup modalClosed={props.logoutPopupToggleHandler} />
      )}
      {props.showProjectInfo && (
        <ProjectInfo
          modalClosed={props.projectInfoToggleHandler}
          version={version}
        />
      )}

      <aside
        id="left-sidebarNav"
        ref={myRef}
        className={` ${
          getIsTenantAccessFromLocalStorage() == true &&
          getUserType === userTypeEnum[4]
            ? 'primary-navbar'
            : ''
        } closeNav`}
      >
        <button
          id="nav-toogle"
          className="menu-toggle"
          onClick={handleChange}
          title={formatMessage('menu')}
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
        <div className="nav-inner">
          <nav>
            <div className="sidebar-header">
              <div
                className="sidebar-logo"
                title={formatMessage('application_title')}
              >
                <img
                  src={logo}
                  alt="did"
                />
              </div>
            </div>
            {userType1 === userTypeEnum[0] ||
            userType1 === userTypeEnum[1] ||
            userType1 === userTypeEnum[2] ||
            userType1 === userTypeEnum[3] ? (
              <ul className="list-unstyled did-menu">
                {isOmsUser && (
                  <React.Fragment>
                    {getTenantIdFromLocalStorage() === '-1' &&
                      findRouteAccess(ModuleType.TenantManagement) && (
                        <li title={formatMessage('tenant_management')}>
                          <NavLink to={RoutesConstants.TenantManagement}>
                            <span className="svgWidth">
                              <TenantManagementIcon />
                            </span>
                            <span className="nav-text">
                              {<FormattedMessage id="factory_management" />}
                            </span>
                          </NavLink>
                        </li>
                      )}
                  </React.Fragment>
                )}

                {getTenantIdFromLocalStorage() === '-1' &&
                  findRouteAccess(ModuleType.ProcessManagement) && (
                    <li>
                      <NavLink
                        title={formatMessage('process_title')}
                        to={RoutesConstants.ProcessManagement}
                      >
                        <span className="svgWidth">
                          <ProcessManagementIcon />{' '}
                        </span>{' '}
                        <span className="nav-text">
                          {<FormattedMessage id="process_title" />}
                        </span>
                      </NavLink>
                    </li>
                  )}

                {getTenantIdFromLocalStorage() === '-1' &&
                  findRouteAccess(ModuleType.DefectiveItems) && (
                    <li>
                      <NavLink
                        title={formatMessage('defective_items')}
                        to={RoutesConstants.DefectiveItems}
                      >
                        <span className="svgWidth">
                          <DefectiveItemsIcon />{' '}
                        </span>{' '}
                        <span className="nav-text">
                          {<FormattedMessage id="defective_items" />}
                        </span>
                      </NavLink>
                    </li>
                  )}

                {getTenantIdFromLocalStorage() !== '-1' &&
                  findRouteAccess(ModuleType.ProductManagement) && (
                    <li>
                      <NavLink
                        title={formatMessage('product_title')}
                        to={RoutesConstants.ProductManagement}
                      >
                        <span className="svgWidth">
                          <span className="product-icon-wrapper">
                            <ProductManagementIcon />
                            {Number(pendingCount) > 0 && (
                              <span
                                className="pending-exclamation-badge"
                                title={formatMessage('correction_request')}
                              >
                                <ExclamationCircleFill className="text-danger pending-exclamation-icon" />
                              </span>
                            )}
                          </span>
                        </span>{' '}
                        <span className="nav-text">
                          {<FormattedMessage id="product_title" />}
                        </span>
                      </NavLink>
                    </li>
                  )}

                {getTenantIdFromLocalStorage() !== '-1' &&
                  findRouteAccess(ModuleType.ProcessTemplateManagement) && (
                    <li>
                      <NavLink
                        title={formatMessage('process_template_mgmt')}
                        to={RoutesConstants.ProcessTemplateManagement}
                      >
                        <span className="svgWidth">
                          <ProcessTemplateManagementIcon />
                        </span>
                        <span className="nav-text">
                          {<FormattedMessage id="process_template_mgmt" />}
                        </span>
                      </NavLink>
                    </li>
                  )}

                {getTenantIdFromLocalStorage() !== '-1' &&
                  findRouteAccess(ModuleType.CheckItemTemplate) && (
                    <li>
                      <NavLink
                        title={formatMessage('check_item_template')}
                        to={RoutesConstants.CheckItemTemplate}
                      >
                        <span className="svgWidth">
                          <CheckItemTemplateIcon />
                        </span>
                        <span className="nav-text">
                          {<FormattedMessage id="check_item_template" />}
                        </span>
                      </NavLink>
                    </li>
                  )}

                {getTenantIdFromLocalStorage() !== '-1' &&
                  findRouteAccess(ModuleType.DimensionTableFields) && (
                    <li>
                      <NavLink
                        title={formatMessage('dimension_table_fields')}
                        to={RoutesConstants.DimensionTableFields}
                      >
                        <span className="svgWidth">
                          <DimensionIcon />
                        </span>
                        <span className="nav-text">
                          {<FormattedMessage id="dimension_table_fields" />}
                        </span>
                      </NavLink>
                    </li>
                  )}

                {getTenantIdFromLocalStorage() !== '-1' &&
                  findRouteAccess(ModuleType.KishuManagement) && (
                    <li>
                      <NavLink
                        title={formatMessage('kishu_title')}
                        to={RoutesConstants.KishuManagement}
                      >
                        <span className="svgWidth">
                          <KishuManagementIcon />
                        </span>{' '}
                        <span className="nav-text">
                          {<FormattedMessage id="kishu_title" />}
                        </span>
                      </NavLink>
                    </li>
                  )}

                {getTenantIdFromLocalStorage() !== '-1' &&
                  findRouteAccess(ModuleType.TeplarPrintTemplateManagement) && (
                    <li>
                      <NavLink
                        title={formatMessage('teplar_print_nav_title')}
                        to={RoutesConstants.TeplarPrintTemplateManagement}
                      >
                        <span className="svgWidth">
                          <TeplarPrintTemplateManagementIcon />
                        </span>{' '}
                        <span className="nav-text">
                          {<FormattedMessage id="teplar_print_nav_title" />}
                        </span>
                      </NavLink>
                    </li>
                  )}

                {getTenantIdFromLocalStorage() !== '-1' &&
                  findRouteAccess(ModuleType.TrayManagement) && (
                    <li>
                      <NavLink
                        title={formatMessage('tray_management')}
                        to={RoutesConstants.TrayManagement}
                      >
                        <span className="svgWidth">
                          <TrayManagementIcon />{' '}
                        </span>
                        <span className="nav-text">
                          {<FormattedMessage id="tray_management" />}
                        </span>
                      </NavLink>
                    </li>
                  )}

                {getTenantIdFromLocalStorage() !== '-1' &&
                  findRouteAccess(ModuleType.ActiveTrayManagement) && (
                    <li>
                      <NavLink
                        title={formatMessage('active_tray_management')}
                        to={RoutesConstants.ActiveTrayManagement}
                      >
                        <span className="svgWidth">
                          <ActiveTrayManagementIcon />
                        </span>
                        <span className="nav-text">
                          {<FormattedMessage id="active_tray_management" />}
                        </span>
                      </NavLink>
                    </li>
                  )}

                {getTenantIdFromLocalStorage() !== '-1' &&
                  findRouteAccess(ModuleType.GroupManagement) && (
                    <li>
                      <NavLink
                        title={formatMessage('group_management')}
                        to={RoutesConstants.GroupManagement}
                      >
                        <span className="svgWidth">
                          <GroupManagementIcon />
                        </span>
                        <span className="nav-text">
                          {<FormattedMessage id="group_management" />}
                        </span>
                      </NavLink>
                    </li>
                  )}

                {getTenantIdFromLocalStorage() !== '-1' &&
                  findRouteAccess(ModuleType.TrayTagReassignment) && (
                    <li>
                      <NavLink
                        title={formatMessage('tray_tag_reassignment')}
                        to={RoutesConstants.TrayTagReassignment}
                      >
                        <span className="svgWidth">
                          <TrayTagReassignmentIcon />
                        </span>
                        <span className="nav-text">
                          {<FormattedMessage id="tray_tag_reassignment" />}
                        </span>
                      </NavLink>
                    </li>
                  )}

                {getTenantIdFromLocalStorage() !== '-1' &&
                  findRouteAccess(ModuleType.OrderViewDashboard) && (
                    <li>
                      <NavLink
                        title={formatMessage('order_table')}
                        to={RoutesConstants.OrderTableView}
                      >
                        <span className="svgWidth">
                          <OrderTableViewIcon />
                        </span>
                        <span className="nav-text">
                          {<FormattedMessage id="order_table" />}
                        </span>
                      </NavLink>
                    </li>
                  )}

                {getTenantIdFromLocalStorage() !== '-1' &&
                  findRouteAccess(ModuleType.OperatorMenu) && (
                    <li>
                      <NavLink
                        title={formatMessage('process')}
                        to={RoutesConstants.OperatorListDetail}
                      >
                        <span className="svgWidth">
                          <OperatorMenuIcon />
                        </span>{' '}
                        <span className="nav-text">
                          {<FormattedMessage id="process" />}
                        </span>
                      </NavLink>
                    </li>
                  )}

                {getTenantIdFromLocalStorage() !== '-1' &&
                  findRouteAccess(ModuleType.HKRScheduleView) && (
                    <li>
                      <NavLink
                        title={formatMessage('hkr_schedule')}
                        to={RoutesConstants.HKRDashboarData}
                      >
                        <span className="svgWidth">
                          <HKRScheduleDataIcon />
                        </span>
                        <span className="nav-text">
                          {<FormattedMessage id="hkr_schedule" />}
                        </span>
                      </NavLink>
                    </li>
                  )}

                {getTenantIdFromLocalStorage() !== '-1' &&
                  findRouteAccess(ModuleType.BomSearch) && (
                    <li>
                      <NavLink
                        title={formatMessage('bom_search')}
                        to={RoutesConstants.BomSearch}
                      >
                        <span className="svgWidth">
                          <BomSearchIcon />
                        </span>
                        <span className="nav-text">
                          {<FormattedMessage id="bom_search" />}
                        </span>
                      </NavLink>
                    </li>
                  )}

                {getTenantIdFromLocalStorage() !== '-1' &&
                  findRouteAccess(ModuleType.OperatorMenu) && (
                    <li>
                      <NavLink
                        title={formatMessage('Nonconformity')}
                        to={RoutesConstants.Nonconformity}
                      >
                        <span className="svgWidth">
                          <NonConfirmatoryIcon />
                        </span>{' '}
                        <span className="nav-text">
                          {<FormattedMessage id="Nonconformity" />}
                        </span>
                      </NavLink>
                    </li>
                  )}

                {getTenantIdFromLocalStorage() !== '-1' &&
                  findRouteAccess(ModuleType.OperatorMenu) && (
                    <li>
                      <NavLink
                        title={formatMessage('nonconformity_report')}
                        to={RoutesConstants.NonconformityReport}
                      >
                        <span className="svgWidth">
                          <NonconformityReportIcon />
                        </span>{' '}
                        <span className="nav-text">
                          {<FormattedMessage id="nonconformity_report" />}
                        </span>
                      </NavLink>
                    </li>
                  )}

                {getTenantIdFromLocalStorage() !== '-1' && true && (
                  <li>
                    <NavLink
                      title={formatMessage('equipment_management')}
                      to={RoutesConstants.EquipmentManagement}
                    >
                      <span className="svgWidth">
                        <ToolManagementIcon />
                      </span>
                      <span className="nav-text">
                        {<FormattedMessage id="equipment_management" />}
                      </span>
                    </NavLink>
                  </li>
                )}

                {getTenantIdFromLocalStorage() !== '-1' &&
                  // findRouteAccess(ModuleType.ToolCheckItemTemplate)  && (
                  true && (
                    <li>
                      <NavLink
                        title={formatMessage('tool_check_item_template')}
                        to={RoutesConstants.ToolCheckItemTemplate}
                      >
                        <span className="svgWidth">
                          <ToolCheckItemTemplateIcon />
                        </span>
                        <span className="nav-text">
                          {<FormattedMessage id="tool_check_item_template" />}
                        </span>
                      </NavLink>
                    </li>
                  )}

                {getTenantIdFromLocalStorage() !== '-1' &&
                  findRouteAccess(ModuleType.AIMSPortal) && (
                    <li>
                      <NavLink
                        title={formatMessage('aims_text')}
                        to={RoutesConstants.AIMSPortal}
                      >
                        <span className="svgWidth">
                          <AIMSPortalIcon />
                        </span>
                        <span className="nav-text">
                          {<FormattedMessage id="aims_text" />}
                        </span>
                      </NavLink>
                    </li>
                  )}

                {getTenantIdFromLocalStorage() !== '-1' &&
                  findRouteAccess(ModuleType.HolidayCalendar) && (
                    <li>
                      <NavLink
                        title={formatMessage('factory_schedule')}
                        to={RoutesConstants.HolidayCalendar}
                      >
                        <span className="svgWidth">
                          <HolidayCalendarIcon />
                        </span>
                        <span className="nav-text">
                          {<FormattedMessage id="factory_schedule" />}
                        </span>
                      </NavLink>
                    </li>
                  )}

                {getTenantIdFromLocalStorage() === '-1' &&
                  findRouteAccess(ModuleType.UserLogs) && (
                    <li>
                      <NavLink
                        title={formatMessage('user_logs')}
                        to={RoutesConstants.UserLogs}
                      >
                        <span className="svgWidth">
                          <UserLogsIcon />
                        </span>
                        <span className="nav-text">
                          {<FormattedMessage id="user_logs" />}
                        </span>
                      </NavLink>
                    </li>
                  )}

                {getTenantIdFromLocalStorage() === '-1' &&
                  findRouteAccess(ModuleType.FactoryAccess) && (
                    <li>
                      <NavLink
                        title={formatMessage('factory_access')}
                        to={RoutesConstants.FactoryAccess}
                      >
                        <span className="svgWidth">
                          <FactoryAccessIcon />
                        </span>
                        <span className="nav-text">
                          {<FormattedMessage id="factory_access" />}
                        </span>
                      </NavLink>
                    </li>
                  )}

                {/* {getTenantIdFromLocalStorage() === '-1' && */}
                {findRouteAccess(ModuleType.UserManagement) && (
                  <li>
                    <NavLink
                      title={formatMessage('system_user')}
                      to={RoutesConstants.UserManagement}
                    >
                      <span className="svgWidth">
                        <UserManagementIcon />
                      </span>
                      <span className="nav-text">
                        {<FormattedMessage id="system_user" />}
                      </span>
                    </NavLink>
                  </li>
                )}

                {getTenantIdFromLocalStorage() !== '-1' &&
                  findRouteAccess(ModuleType.UserLogs) && (
                    <li>
                      <NavLink
                        title={formatMessage('user_logs')}
                        to={RoutesConstants.UserLogs}
                      >
                        <span className="svgWidth">
                          <UserLogsIcon />
                        </span>
                        <span className="nav-text">
                          {<FormattedMessage id="user_logs" />}
                        </span>
                      </NavLink>
                    </li>
                  )}

                {isCompany && (
                  <React.Fragment>
                    {/* {findRouteAccess(ModuleType.CompanyUserManagement) && ( */}
                    {/* <li title={formatMessage('system_user')}>
                    <NavLink to={RoutesConstants.UserManagement}>
                      <span className="svgWidth">
                        <svg
                          clipRule="evenodd"
                          fillRule="evenodd"
                          fill="rgb(134, 137, 144)"
                          height="22"
                          width="22"
                          strokeLinejoin="round"
                          strokeMiterlimit="2"
                          viewBox="0 0 24 24"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g id="Icon">
                            <path d="m11.5 20.263h-8.55c-.053 0-.104-.022-.141-.059-.038-.038-.059-.088-.059-.141 0-.001 0-1.451 0-1.451 0-.83.593-1.562 1.507-2.184 1.632-1.114 4.273-1.816 7.243-1.816.414 0 .75-.336.75-.75 0-.413-.336-.75-.75-.75-3.322 0-6.263.831-8.089 2.076-1.393.95-2.161 2.157-2.161 3.424v1.451c0 .45.179.883.498 1.202.319.318.751.498 1.202.498h8.55c.414-.001.75-.337.75-.751 0-.413-.336-.75-.75-.749z" />
                            <path d="m11.5 1.25c-3.036 0-5.5 2.464-5.5 5.5s2.464 5.5 5.5 5.5 5.5-2.464 5.5-5.5-2.464-5.5-5.5-5.5zm0 1.5c2.208 0 4 1.792 4 4s-1.792 4-4 4-4-1.792-4-4 1.792-4 4-4z" />
                            <path d="m17.5 13.938c-1.966 0-3.562 1.596-3.562 3.562s1.596 3.563 3.562 3.563 3.563-1.597 3.563-3.563-1.597-3.562-3.563-3.562zm0 1.5c1.138 0 2.063.924 2.063 2.062s-.925 2.063-2.063 2.063-2.063-.925-2.063-2.063.925-2.062 2.063-2.062z" />
                            <path d="m18.25 14.687v-1.687c0-.414-.336-.75-.75-.75s-.75.336-.75.75v1.688c0 .413.336.75.75.75.414-.001.75-.337.75-.751z" />
                            <path d="m20.019 16.042 1.193-1.194c.293-.292.293-.768 0-1.06-.292-.293-.768-.293-1.06 0l-1.194 1.193c-.292.293-.292.768 0 1.061.293.292.768.292 1.061 0z" />
                            <path d="m20.312 18.25h1.688c.414 0 .75-.336.75-.75s-.336-.75-.75-.75h-1.688c-.413 0-.749.336-.749.75-.001.414.336.75.749.75z" />
                            <path d="m18.958 20.019 1.194 1.193c.292.293.768.293 1.06 0 .293-.292.293-.768 0-1.06l-1.193-1.194c-.293-.292-.768-.292-1.061 0-.292.293-.292.768 0 1.061z" />
                            <path d="m16.75 20.312v1.688c0 .414.336.75.75.75s.75-.336.75-.75v-1.688c0-.413-.336-.749-.75-.75-.414 0-.75.337-.75.75z" />
                            <path d="m14.981 18.958-1.193 1.194c-.293.292-.293.768 0 1.06.292.293.768.293 1.06 0l1.194-1.193c.292-.293.292-.768 0-1.061-.293-.292-.768-.292-1.061 0z" />
                            <path d="m14.687 16.75h-1.687c-.414 0-.75.336-.75.75s.336.75.75.75h1.687c.414 0 .751-.336.75-.75 0-.414-.336-.75-.75-.75z" />
                            <path d="m16.042 14.981-1.194-1.193c-.292-.293-.768-.293-1.06 0-.293.292-.293.768 0 1.06l1.193 1.194c.293.292.768.292 1.061 0 .292-.293.292-.768 0-1.061z" />
                          </g>
                        </svg>
                      </span>
                      <span className="nav-text">{<FormattedMessage id="system_user" />}</span>
                    </NavLink>
                  </li> */}
                    {/* )} */}
                  </React.Fragment>
                )}
                {getIsTenantAccessFromLocalStorage() == true &&
                (getUserType === userTypeEnum[4] ||
                  getUserType === userTypeEnum[0] ||
                  getUserType === userTypeEnum[1]) ? (
                  <React.Fragment>
                    {getIsTenantAccessFromLocalStorage() == true && (
                      <li
                        title={formatMessage('exit_tenant')}
                        id="exit"
                      >
                        <a
                          className="btn btn-light-danger"
                          data-toggle="modal"
                          onClick={() => exitTenant()}
                        >
                          <span className="svgWidth">
                            <ExitTenantIcon />
                          </span>
                          <span className="nav-text">
                            <FormattedMessage id="exit_tenant" />{' '}
                          </span>
                        </a>
                      </li>
                    )}
                  </React.Fragment>
                ) : (
                  ''
                )}
              </ul>
            ) : (
              <ul className="list-unstyled did-menu">
                {isOmsUser && (
                  <React.Fragment>
                    {getTenantIdFromLocalStorage() === '-1' &&
                      findRouteAccess(ModuleType.TenantManagement) && (
                        <li title={formatMessage('tenant_management')}>
                          <NavLink to={RoutesConstants.TenantManagement}>
                            <span className="svgWidth">
                              <TenantManagementIcon />
                            </span>
                            <span className="nav-text">
                              {<FormattedMessage id="factory_management" />}
                            </span>
                          </NavLink>
                        </li>
                      )}
                  </React.Fragment>
                )}

                {getTenantIdFromLocalStorage() === '-1' &&
                  findRouteAccess(ModuleType.ProcessManagement) && (
                    <li>
                      <NavLink
                        title={formatMessage('process_title')}
                        to={RoutesConstants.ProcessManagement}
                      >
                        <span className="svgWidth">
                          <ProcessManagementIcon />{' '}
                        </span>{' '}
                        <span className="nav-text">
                          {<FormattedMessage id="process_title" />}
                        </span>
                      </NavLink>
                    </li>
                  )}

                {getTenantIdFromLocalStorage() === '-1' &&
                  findRouteAccess(ModuleType.DefectiveItems) && (
                    <li>
                      <NavLink
                        title={formatMessage('defective_items')}
                        to={RoutesConstants.DefectiveItems}
                      >
                        <span className="svgWidth">
                          <DefectiveItemsIcon />{' '}
                        </span>{' '}
                        <span className="nav-text">
                          {<FormattedMessage id="defective_items" />}
                        </span>
                      </NavLink>
                    </li>
                  )}

                {getTenantIdFromLocalStorage() !== '-1' &&
                  findRouteAccess(ModuleType.ProductManagement) && (
                    <li>
                      <NavLink
                        title={formatMessage('product_title')}
                        to={RoutesConstants.ProductManagement}
                      >
                        <span className="svgWidth">
                          <span className="product-icon-wrapper">
                            <ProductManagementIcon />
                            {Number(pendingCount) > 0 && (
                              <span
                                className="pending-exclamation-badge"
                                title={formatMessage('correction_request')}
                              >
                                <ExclamationCircleFill className="text-danger pending-exclamation-icon" />
                              </span>
                            )}
                          </span>
                        </span>{' '}
                        <span className="nav-text">
                          {<FormattedMessage id="product_title" />}
                        </span>
                      </NavLink>
                    </li>
                  )}

                {getTenantIdFromLocalStorage() !== '-1' &&
                  findRouteAccess(ModuleType.ProcessTemplateManagement) && (
                    <li>
                      <NavLink
                        title={formatMessage('process_template_mgmt')}
                        to={RoutesConstants.ProcessTemplateManagement}
                      >
                        <span className="svgWidth">
                          <ProcessTemplateManagementIcon />
                        </span>
                        <span className="nav-text">
                          {<FormattedMessage id="process_template_mgmt" />}
                        </span>
                      </NavLink>
                    </li>
                  )}

                {getTenantIdFromLocalStorage() !== '-1' &&
                  findRouteAccess(ModuleType.CheckItemTemplate) && (
                    <li>
                      <NavLink
                        title={formatMessage('check_item_template')}
                        to={RoutesConstants.CheckItemTemplate}
                      >
                        <span className="svgWidth">
                          <CheckItemTemplateIcon />
                        </span>
                        <span className="nav-text">
                          {<FormattedMessage id="check_item_template" />}
                        </span>
                      </NavLink>
                    </li>
                  )}

                {getTenantIdFromLocalStorage() !== '-1' &&
                  findRouteAccess(ModuleType.DimensionTableFields) && (
                    <li>
                      <NavLink
                        title={formatMessage('dimension_table_fields')}
                        to={RoutesConstants.DimensionTableFields}
                      >
                        <span className="svgWidth">
                          <DimensionIcon />
                        </span>
                        <span className="nav-text">
                          {<FormattedMessage id="dimension_table_fields" />}
                        </span>
                      </NavLink>
                    </li>
                  )}

                {getTenantIdFromLocalStorage() !== '-1' &&
                  findRouteAccess(ModuleType.KishuManagement) && (
                    <li>
                      <NavLink
                        title={formatMessage('kishu_title')}
                        to={RoutesConstants.KishuManagement}
                      >
                        <span className="svgWidth">
                          <KishuManagementIcon />
                        </span>{' '}
                        <span className="nav-text">
                          {<FormattedMessage id="kishu_title" />}
                        </span>
                      </NavLink>
                    </li>
                  )}

                {getTenantIdFromLocalStorage() !== '-1' &&
                  findRouteAccess(ModuleType.TeplarPrintTemplateManagement) && (
                    <li>
                      <NavLink
                        title={formatMessage('teplar_print_nav_title')}
                        to={RoutesConstants.TeplarPrintTemplateManagement}
                      >
                        <span className="svgWidth">
                          <TeplarPrintTemplateManagementIcon />
                        </span>{' '}
                        <span className="nav-text">
                          {<FormattedMessage id="teplar_print_nav_title" />}
                        </span>
                      </NavLink>
                    </li>
                  )}

                {getTenantIdFromLocalStorage() !== '-1' &&
                  findRouteAccess(ModuleType.TrayManagement) && (
                    <li>
                      <NavLink
                        title={formatMessage('tray_management')}
                        to={RoutesConstants.TrayManagement}
                      >
                        <span className="svgWidth">
                          <TrayManagementIcon />{' '}
                        </span>
                        <span className="nav-text">
                          {<FormattedMessage id="tray_management" />}
                        </span>
                      </NavLink>
                    </li>
                  )}

                {getTenantIdFromLocalStorage() !== '-1' &&
                  findRouteAccess(ModuleType.ActiveTrayManagement) && (
                    <li>
                      <NavLink
                        title={formatMessage('active_tray_management')}
                        to={RoutesConstants.ActiveTrayManagement}
                      >
                        <span className="svgWidth">
                          <ActiveTrayManagementIcon />
                        </span>
                        <span className="nav-text">
                          {<FormattedMessage id="active_tray_management" />}
                        </span>
                      </NavLink>
                    </li>
                  )}

                {getTenantIdFromLocalStorage() !== '-1' &&
                  findRouteAccess(ModuleType.GroupManagement) && (
                    <li>
                      <NavLink
                        title={formatMessage('group_management')}
                        to={RoutesConstants.GroupManagement}
                      >
                        <span className="svgWidth">
                          <GroupManagementIcon />
                        </span>
                        <span className="nav-text">
                          {<FormattedMessage id="group_management" />}
                        </span>
                      </NavLink>
                    </li>
                  )}

                {getTenantIdFromLocalStorage() !== '-1' &&
                  findRouteAccess(ModuleType.TrayTagReassignment) && (
                    <li>
                      <NavLink
                        title={formatMessage('tray_tag_reassignment')}
                        to={RoutesConstants.TrayTagReassignment}
                      >
                        <span className="svgWidth">
                          <TrayTagReassignmentIcon />
                        </span>
                        <span className="nav-text">
                          {<FormattedMessage id="tray_tag_reassignment" />}
                        </span>
                      </NavLink>
                    </li>
                  )}

                {getTenantIdFromLocalStorage() !== '-1' &&
                  findRouteAccess(ModuleType.OrderViewDashboard) && (
                    <li>
                      <NavLink
                        title={formatMessage('order_table')}
                        to={RoutesConstants.OrderTableView}
                      >
                        <span className="svgWidth">
                          <OrderTableViewIcon />
                        </span>
                        <span className="nav-text">
                          {<FormattedMessage id="order_table" />}
                        </span>
                      </NavLink>
                    </li>
                  )}

                {getTenantIdFromLocalStorage() !== '-1' &&
                  findRouteAccess(ModuleType.OperatorMenu) && (
                    <li>
                      <NavLink
                        title={formatMessage('process')}
                        to={RoutesConstants.OperatorListDetail}
                      >
                        <span className="svgWidth">
                          <OperatorMenuIcon />
                        </span>{' '}
                        <span className="nav-text">
                          {<FormattedMessage id="process" />}
                        </span>
                      </NavLink>
                    </li>
                  )}

                {getTenantIdFromLocalStorage() !== '-1' &&
                  findRouteAccess(ModuleType.HKRScheduleView) && (
                    <li>
                      <NavLink
                        title={formatMessage('hkr_schedule')}
                        to={RoutesConstants.HKRDashboarData}
                      >
                        <span className="svgWidth">
                          <HKRScheduleDataIcon />
                        </span>
                        <span className="nav-text">
                          {<FormattedMessage id="hkr_schedule" />}
                        </span>
                      </NavLink>
                    </li>
                  )}

                {getTenantIdFromLocalStorage() !== '-1' &&
                  findRouteAccess(ModuleType.BomSearch) && (
                    <li>
                      <NavLink
                        title={formatMessage('bom_search')}
                        to={RoutesConstants.BomSearch}
                      >
                        <span className="svgWidth">
                          <BomSearchIcon />
                        </span>
                        <span className="nav-text">
                          {<FormattedMessage id="bom_search" />}
                        </span>
                      </NavLink>
                    </li>
                  )}

                {getTenantIdFromLocalStorage() !== '-1' &&
                  findRouteAccess(ModuleType.OperatorMenu) && (
                    <li>
                      <NavLink
                        title={formatMessage('Nonconformity')}
                        to={RoutesConstants.Nonconformity}
                      >
                        <span className="svgWidth">
                          <NonConfirmatoryIcon />
                        </span>{' '}
                        <span className="nav-text">
                          {<FormattedMessage id="Nonconformity" />}
                        </span>
                      </NavLink>
                    </li>
                  )}

                {getTenantIdFromLocalStorage() !== '-1' &&
                  findRouteAccess(ModuleType.OperatorMenu) && (
                    <li>
                      <NavLink
                        title={formatMessage('nonconformity_report')}
                        to={RoutesConstants.NonconformityReport}
                      >
                        <span className="svgWidth">
                          <NonconformityReportIcon />
                        </span>{' '}
                        <span className="nav-text">
                          {<FormattedMessage id="nonconformity_report" />}
                        </span>
                      </NavLink>
                    </li>
                  )}

                {getTenantIdFromLocalStorage() !== '-1' && true && (
                  <li>
                    <NavLink
                      title={formatMessage('equipment_management')}
                      to={RoutesConstants.EquipmentManagement}
                    >
                      <span className="svgWidth">
                        <ToolManagementIcon />
                      </span>
                      <span className="nav-text">
                        {<FormattedMessage id="equipment_management" />}
                      </span>
                    </NavLink>
                  </li>
                )}

                {getTenantIdFromLocalStorage() !== '-1' &&
                  // findRouteAccess(ModuleType.ToolCheckItemTemplate)  && (
                  true && (
                    <li>
                      <NavLink
                        title={formatMessage('tool_check_item_template')}
                        to={RoutesConstants.ToolCheckItemTemplate}
                      >
                        <span className="svgWidth">
                          <ToolCheckItemTemplateIcon />
                        </span>
                        <span className="nav-text">
                          {<FormattedMessage id="tool_check_item_template" />}
                        </span>
                      </NavLink>
                    </li>
                  )}

                {getTenantIdFromLocalStorage() !== '-1' &&
                  findRouteAccess(ModuleType.AIMSPortal) && (
                    <li>
                      <NavLink
                        title={formatMessage('aims_text')}
                        to={RoutesConstants.AIMSPortal}
                      >
                        <span className="svgWidth">
                          <AIMSPortalIcon />
                        </span>
                        <span className="nav-text">
                          {<FormattedMessage id="aims_text" />}
                        </span>
                      </NavLink>
                    </li>
                  )}

                {getTenantIdFromLocalStorage() !== '-1' &&
                  findRouteAccess(ModuleType.HolidayCalendar) && (
                    <li>
                      <NavLink
                        title={formatMessage('factory_schedule')}
                        to={RoutesConstants.HolidayCalendar}
                      >
                        <span className="svgWidth">
                          <HolidayCalendarIcon />
                        </span>
                        <span className="nav-text">
                          {<FormattedMessage id="factory_schedule" />}
                        </span>
                      </NavLink>
                    </li>
                  )}

                {getTenantIdFromLocalStorage() === '-1' &&
                  findRouteAccess(ModuleType.FactoryAccess) && (
                    <li>
                      <NavLink
                        title={formatMessage('factory_access')}
                        to={RoutesConstants.FactoryAccess}
                      >
                        <span className="svgWidth">
                          <FactoryAccessIcon />
                        </span>
                        <span className="nav-text">
                          {<FormattedMessage id="factory_access" />}
                        </span>
                      </NavLink>
                    </li>
                  )}

                {/* {getTenantIdFromLocalStorage() === '-1' && */}
                {findRouteAccess(ModuleType.UserManagement) && (
                  <li>
                    <NavLink
                      title={formatMessage('system_user')}
                      to={RoutesConstants.UserManagement}
                    >
                      <span className="svgWidth">
                        <UserManagementIcon />
                      </span>
                      <span className="nav-text">
                        {<FormattedMessage id="system_user" />}
                      </span>
                    </NavLink>
                  </li>
                )}

                {getTenantIdFromLocalStorage() !== '-1' &&
                  findRouteAccess(ModuleType.UserLogs) && (
                    <li>
                      <NavLink
                        title={formatMessage('user_logs')}
                        to={RoutesConstants.UserLogs}
                      >
                        <span className="svgWidth">
                          <UserLogsIcon />
                        </span>
                        <span className="nav-text">
                          {<FormattedMessage id="user_logs" />}
                        </span>
                      </NavLink>
                    </li>
                  )}

                {isCompany && (
                  <React.Fragment>
                    {/* {findRouteAccess(ModuleType.CompanyUserManagement) && ( */}
                    {/* <li title={formatMessage('system_user')}>
                    <NavLink to={RoutesConstants.UserManagement}>
                      <span className="svgWidth">
                        <svg
                          clipRule="evenodd"
                          fillRule="evenodd"
                          fill="rgb(134, 137, 144)"
                          height="22"
                          width="22"
                          strokeLinejoin="round"
                          strokeMiterlimit="2"
                          viewBox="0 0 24 24"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g id="Icon">
                            <path d="m11.5 20.263h-8.55c-.053 0-.104-.022-.141-.059-.038-.038-.059-.088-.059-.141 0-.001 0-1.451 0-1.451 0-.83.593-1.562 1.507-2.184 1.632-1.114 4.273-1.816 7.243-1.816.414 0 .75-.336.75-.75 0-.413-.336-.75-.75-.75-3.322 0-6.263.831-8.089 2.076-1.393.95-2.161 2.157-2.161 3.424v1.451c0 .45.179.883.498 1.202.319.318.751.498 1.202.498h8.55c.414-.001.75-.337.75-.751 0-.413-.336-.75-.75-.749z" />
                            <path d="m11.5 1.25c-3.036 0-5.5 2.464-5.5 5.5s2.464 5.5 5.5 5.5 5.5-2.464 5.5-5.5-2.464-5.5-5.5-5.5zm0 1.5c2.208 0 4 1.792 4 4s-1.792 4-4 4-4-1.792-4-4 1.792-4 4-4z" />
                            <path d="m17.5 13.938c-1.966 0-3.562 1.596-3.562 3.562s1.596 3.563 3.562 3.563 3.563-1.597 3.563-3.563-1.597-3.562-3.563-3.562zm0 1.5c1.138 0 2.063.924 2.063 2.062s-.925 2.063-2.063 2.063-2.063-.925-2.063-2.063.925-2.062 2.063-2.062z" />
                            <path d="m18.25 14.687v-1.687c0-.414-.336-.75-.75-.75s-.75.336-.75.75v1.688c0 .413.336.75.75.75.414-.001.75-.337.75-.751z" />
                            <path d="m20.019 16.042 1.193-1.194c.293-.292.293-.768 0-1.06-.292-.293-.768-.293-1.06 0l-1.194 1.193c-.292.293-.292.768 0 1.061.293.292.768.292 1.061 0z" />
                            <path d="m20.312 18.25h1.688c.414 0 .75-.336.75-.75s-.336-.75-.75-.75h-1.688c-.413 0-.749.336-.749.75-.001.414.336.75.749.75z" />
                            <path d="m18.958 20.019 1.194 1.193c.292.293.768.293 1.06 0 .293-.292.293-.768 0-1.06l-1.193-1.194c-.293-.292-.768-.292-1.061 0-.292.293-.292.768 0 1.061z" />
                            <path d="m16.75 20.312v1.688c0 .414.336.75.75.75s.75-.336.75-.75v-1.688c0-.413-.336-.749-.75-.75-.414 0-.75.337-.75.75z" />
                            <path d="m14.981 18.958-1.193 1.194c-.293.292-.293.768 0 1.06.292.293.768.293 1.06 0l1.194-1.193c.292-.293.292-.768 0-1.061-.293-.292-.768-.292-1.061 0z" />
                            <path d="m14.687 16.75h-1.687c-.414 0-.75.336-.75.75s.336.75.75.75h1.687c.414 0 .751-.336.75-.75 0-.414-.336-.75-.75-.75z" />
                            <path d="m16.042 14.981-1.194-1.193c-.292-.293-.768-.293-1.06 0-.293.292-.293.768 0 1.06l1.193 1.194c.293.292.768.292 1.061 0 .292-.293.292-.768 0-1.061z" />
                          </g>
                        </svg>
                      </span>
                      <span className="nav-text">{<FormattedMessage id="system_user" />}</span>
                    </NavLink>
                  </li> */}
                    {/* )} */}
                  </React.Fragment>
                )}
                {getIsTenantAccessFromLocalStorage() == true &&
                (getUserType === userTypeEnum[4] ||
                  getUserType === userTypeEnum[0] ||
                  getUserType === userTypeEnum[1]) ? (
                  <React.Fragment>
                    {getIsTenantAccessFromLocalStorage() == true && (
                      <li
                        title={formatMessage('exit_tenant')}
                        id="exit"
                      >
                        <a
                          className="btn btn-light-danger"
                          data-toggle="modal"
                          onClick={() => exitTenant()}
                        >
                          <span className="svgWidth">
                            <ExitTenantIcon />
                          </span>
                          <span className="nav-text">
                            <FormattedMessage id="exit_tenant" />{' '}
                          </span>
                        </a>
                      </li>
                    )}
                  </React.Fragment>
                ) : (
                  ''
                )}
              </ul>
            )}
          </nav>
        </div>
        <div className="aside-footer">
          <ul>
            <li
              title={formatMessage('profile')}
              onClick={props.UserProfileToggleHandler}
            >
              <span className="circle_icons">
                <ProfileIcon />
              </span>
              <span className="nav-text">
                <FormattedMessage id="profile" />
              </span>
            </li>
            <li
              data-testid="Logout"
              title={formatMessage('logout')}
              onClick={props.logoutPopupToggleHandler}
            >
              <span className="circle_icons">
                <LogoutIcon />
              </span>
              <span className="nav-text"> {formatMessage('logout')}</span>
            </li>
            <li></li>
            <li
              className="version"
              // onClick={props.projectInfoToggleHandler}
            >
              {' '}
              <span>v{version}</span>
            </li>
          </ul>
        </div>
      </aside>
    </React.Fragment>
  );
};

export default UserProfilePopupHOC(
  LogoutPopupHOC(ProjectInfoHOC(injectIntl(observer(LeftNavBar))))
);
